export default __webpack_public_path__ + "static/media/back-license.d3ae43d5.png";